import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

import { useTranslate } from '@im/react-localization';

type PropTypes = {
  inWarehouseColumnFlag: any;
  warehouseStockDetailUpdate: any;
};
const WarehouseINGridData = (props: PropTypes) => {
  const translate = useTranslate();
  const { inWarehouseColumnFlag, warehouseStockDetailUpdate } = props;

  return (
    <>
      <WarehouseDetailsBody container>
        <Grid
          container
          sx={{ alignContent: 'flex-start', display: 'flex', flex: 1 }}
        >
          <WarehouseTableHeader container>
            {inWarehouseColumnFlag.locationCodeColumn ? (
              <Grid item xs={3}>
                {translate('Warehouse.ColumnLocCode')}
              </Grid>
            ) : (
              <></>
            )}
            {inWarehouseColumnFlag.locationColumn ? (
              <Grid item xs={3}>
                {translate('Warehouse.ColumnLoc')}
              </Grid>
            ) : (
              <></>
            )}
            {inWarehouseColumnFlag.stockColumn ? (
              <Grid item xs={3}>
                {translate('Warehouse.ColumnStock')}
              </Grid>
            ) : (
              <></>
            )}
            {inWarehouseColumnFlag.tatColumn ? (
              <Grid item xs={3}>
                {translate('Warehouse.ColumnTAT')}
              </Grid>
            ) : (
              <></>
            )}
          </WarehouseTableHeader>
          <Box sx={{ height: '300px', overflow: 'auto', width: '100%' }}>
            <Grid container sx={{ paddingLeft: '0rem' }}>
              {warehouseStockDetailUpdate?.map((warehouse: any, i: number) => (
                <>
                  <Grid
                    container
                    key={warehouse.id}
                    sx={{
                      borderBottom: 1,
                      borderBottomColor: '#C4C4C4',
                      justifyContent: 'space-between',
                      p: 1.5,
                    }}
                  >
                    {inWarehouseColumnFlag.locationCodeColumn ? (
                      <Grid item pl={1} xs={3}>
                        {warehouse.name?.toUpperCase() === 'NOTAVAILABLE' ||
                        warehouse.id?.toUpperCase() === 'RESERVED' ? (
                          <>
                            <ReservedIcon component="span">R</ReservedIcon>{' '}
                            &nbsp;
                            {translate('Common.Reserved')}
                          </>
                        ) : (
                          <>{warehouse.id}</>
                        )}
                      </Grid>
                    ) : (
                      <></>
                    )}
                    {inWarehouseColumnFlag.locationColumn ? (
                      <Grid item pl={1} xs={3}>
                        {warehouse.id?.toUpperCase() !== 'RESERVED'
                          ? warehouse.name || '-'
                          : '-'}
                      </Grid>
                    ) : (
                      <></>
                    )}

                    {inWarehouseColumnFlag.stockColumn ? (
                      <Grid item pl={1} xs={3}>
                        {warehouse.id?.toUpperCase() !== 'RESERVED' &&
                        warehouse?.quantityAvailable > 0 ? (
                          <> {translate('Common.Instock')}</>
                        ) : (
                          <>
                            {warehouse.id?.toUpperCase() !== 'RESERVED'
                              ? '-'
                              : ''}
                          </>
                        )}

                        {warehouse.quantityAvailable > 0 &&
                          warehouse.id?.toUpperCase() === 'RESERVED' && (
                            <>{warehouse.quantityAvailable}</>
                          )}
                      </Grid>
                    ) : (
                      <></>
                    )}

                    {inWarehouseColumnFlag.tatColumn ? (
                      <Grid item pl={1} xs={3}>
                        {parseInt(warehouse.etaDate) || '-'}
                      </Grid>
                    ) : (
                      <></>
                    )}
                  </Grid>
                </>
              ))}
            </Grid>
          </Box>
        </Grid>
      </WarehouseDetailsBody>
    </>
  );
};

export default WarehouseINGridData;

const WarehouseDetailsBody = styled(Grid)(() => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'space-between',
  typography: 'body1',
  width: '100%',
}));

const WarehouseTableHeader = styled(Grid)(({ theme }) => ({
  '& .MuiGrid-item': { alignItems: 'flex-end', display: 'flex' },
  backgroundColor: '#F8F8F8',
  borderBottom: 'solid 2px #0077D4',
  display: 'flex',
  flexWrap: 'nowrap',
  fontSize: '14px',
  fontWeight: 'bold',
  justifyContent: 'space-between',
  padding: theme.spacing(3, 1.5, 0.5),
}));

const ReservedIcon = styled(Box)(() => ({
  alignItems: 'center',
  border: '2px solid #18846F',
  color: '#18846F',
  display: 'inline-flex',
  height: 22,
  justifyContent: 'center',
  width: 20,
}));
